import { Platform, StatusBar } from 'react-native';

/**
 * RN `Modal` surfaces and Android edge‑to‑edge can report `useSafeAreaInsets().top === 0`
 * while chrome still draws under the status bar. Mirror the shell `Screen` behavior.
 */
export function effectiveTopInset(insetsTop: number): number {
  const androidStatus =
    Platform.OS === 'android' && typeof StatusBar.currentHeight === 'number' ? StatusBar.currentHeight : 0;
  return Math.max(insetsTop, androidStatus);
}
